let prevBundleState = new Map();
let isCleaning = false;

document.addEventListener('bundler:total_cart_values', function(e) {
  // console.log(`[${(new Date()).toLocaleTimeString()}] !!! BUNDLER EVENT !!!`, e);
  prevBundleState.clear();
  e.detail.applicable_combos?.forEach(combo => {
    Object.entries(combo).forEach(([_, { variant_id, quantity }]) => {
      const q = prevBundleState.get(variant_id) ?? 0;
      prevBundleState.set(variant_id, q + quantity);
    });
  });
  // console.log('Got bundle line items:', prevBundleState);
});

window.addEventListener('pageshow', e => {
  // console.debug('!!! pageshow event !!!');
  if (e.persisted) {
    // we have restored a cached version of the back using the browser back button
    // prompt bundler app for latest state
    window.bndlr.updateCartDiscounts();
  }
});

document.addEventListener('bundler:bundle_widget_created', function(e) {
  const bundlerAtcButton = document.querySelector('.bndlr-add-bundle-to-cart');
  // console.log('Got bundler ATC button:', bundlerAtcButton);
  if (!bundlerAtcButton) return;

  bundlerAtcButton.addEventListener('click', async (e) => {
    // console.log('Bundler ATC button clicked!');
    if (isCleaning) return;
    
    e.stopImmediatePropagation();
    e.preventDefault();
    isCleaning = true;

    try {
      await removeBundlerItemsFromCart();
    } catch (err) {
      console.error('Bundle cleanup failed!', err);
    }

    bundlerAtcButton.click();
    isCleaning = false;
  }, true);  // capture phase
});

async function removeBundlerItemsFromCart() {
  const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
  const updates = {};
  cart.items.forEach(item => {
    const prevQuantity = prevBundleState.get(item.variant_id);
    if (prevQuantity) {
      // updates[item.variant_id] = Math.max(item.quantity - prevQuantity, 0);
      updates[item.variant_id] = 0;
    }
  });
  // console.debug('Bundle updates:', updates);

  if (Object.keys(updates).length === 0) return;
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates })
  });
}
